import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Sidebar } from './Sidebar';

const PUBLIC_PATHS = ['/login', '/signup', '/biblestudy'];

export function AppLayout({ children }) {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const isPublicPage = location.pathname === '/' || PUBLIC_PATHS.some((p) => location.pathname.startsWith(p));

    if (!isAuthenticated || isPublicPage) {
        return <>{children}</>;
    }

    return (
        <div className="flex min-h-screen">
            <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            <div className="flex-1 lg:ml-60 flex flex-col min-h-screen">
                {/* Mobile top bar */}
                <header className="sticky top-0 z-30 flex items-center gap-3 px-4 py-3 bg-white/80 dark:bg-slate-900/80 backdrop-blur border-b border-slate-200 dark:border-slate-800 lg:hidden">
                    <button
                        onClick={() => setSidebarOpen(true)}
                        className="flex items-center justify-center w-9 h-9 rounded-lg text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                        aria-label="Open menu"
                        aria-expanded={sidebarOpen}
                    >
                        <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="18" x2="21" y2="18" />
                        </svg>
                    </button>
                    <span className="font-semibold text-slate-800 dark:text-slate-100">RT Care Groups</span>
                </header>

                {/* Page content */}
                <main className="flex-1">
                    <div className="animate-fade-in">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
}

export default AppLayout;
